<template>
    <div>
        <page-preloader v-if="isLoader" min-height="5rem" />

        <div v-else-if="eans.length" class="bag-details-table c-table">
            <div class="c-thead">
                <div v-text="'Frakcja'" class="c-td" />
                <div v-text="'Produkt'" class="c-td" />
                <div v-text="'Kod EAN'" class="c-td" />
                <div v-text="'Liczba (szt.)'" class="c-td" />
            </div>

            <div class="c-tbody">
                <div
                    v-for="ean in eans"
                    class="c-tr"
                    :key="ean.id"
                >
                    <div class="c-td">
                        <fraction-label
                            style="justify-content: flex-end; font-size: 0;"
                            :fraction="eanFraction(ean.fraction)"
                        />
                    </div>
                    <div class="c-td" v-text="ean.name" />
                    <div class="c-td">
                        <div v-text="'Kod EAN'" class="typo-label" />
                        {{ ean.ean }}
                    </div>
                    <div class="c-td">
                        <div v-text="'Liczba (szt.)'" class="typo-label" />
                        {{ ean.factor || 0 }}
                    </div>
                </div>
            </div>
            <div class="c-tfooter">
                <results-dropdown
                    :per-page="pagination.perPage"
                    :options="[10, 20, 50, 100]"
                    :on-change="changePerPage"
                />

                <the-pagination
                    :pagination="paginationView"
                    @change="changePage"
                />
            </div>
        </div>

        <div v-else v-text="'Brak wyników'" />
    </div>
</template>

<script>
import { FRACTIONS } from '@/utils/constants/drs/fractions'

export default {
    props: {
        bag: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        eans: [],
        isLoader: false,
        totalCount: 0,
        pagination: {
            page: 1,
            perPage: 10
        }
    }),

    methods: {
        eanFraction(fraction) {
            return Object.values(FRACTIONS).find(f => f.id === fraction.id) || null
        },

        async fetchEans() {
            if (!this.bag.package_id) {
                return []
            }
            try {
                this.isLoader = true
                const { data, status } = await this.$store.$api.post(
                    'drs/api/proxy/warehouse/drs/reports/packages/eans',
                    {
                        paging: {
                            number_of_page: this.pagination.page,
                            number_of_rows: this.pagination.perPage,
                            order_by: 'issue_date',
                            order_direction: 'ASC'
                        },
                        package_id: this.bag.package_id
                    }
                )

                if (status !== 200 || !data?.eans) {
                    throw new Error('Failed fetchEans')
                }

                this.totalCount = data?.paging_response?.count || 0

                return data.eans || []
            } catch (error) {
                console.error(error)
                return []
            } finally {
                this.isLoader = false
            }
        },

        async changePerPage(perPage) {
            this.pagination.perPage = perPage
            this.pagination.page = 1

            this.eans = await this.fetchEans()
        },

        async changePage(page) {
            this.pagination.page = page
            this.eans = await this.fetchEans()
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.totalCount / this.pagination.perPage) || 0
        },

        prevPage() {
            return this.pagination.page > 1 ? this.pagination.page - 1 : null
        },

        nextPage() {
            return this.pagination.page < this.totalPages
                ? this.pagination.page + 1
                : null
        },

        paginationView() {
            const { pagination, totalPages, prevPage, nextPage } = this
            return {
                page: pagination.page,
                perPage: pagination.perPage,
                totalPages,
                prevPage,
                nextPage
            }
        }
    },

    async created() {
        this.eans = await this.fetchEans()
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.bag-details-table {
    width: 100%;

    .c-thead, .c-tr {
        padding: 0;
        gap: 0.5rem;
    }

    .c-td {
        width: var(--td-width);
        max-width: var(--td-width);

        &:nth-child(1) {
            --td-width: 58px;
        }
        &:nth-child(2) {
            --td-width: 40%;
        }
        &:nth-child(3) {
            --td-width: 20%;
        }
        &:nth-child(4) {
            --td-width: 10%;
        }

        .typo-label {
            display: none;
        }
    }

    .c-tr {
        &:nth-child(odd) {
            background-color: var(--color-gray-100);
            border-bottom: 1px solid var(--color-gray-200);
        }
    }

    @include media-breakpoint-down(md) {
        .c-thead {
            display: none;
        }

        .c-tr {
            --gap: 0.5rem;
            padding: 1rem;
            flex-wrap: wrap;
            flex-direction: row;
        }

        .c-td {
            padding: 0;

            &:nth-child(1) {
                padding-top: 2px;
                --td-width: 24px;
            }

            &:nth-child(2) {
                --td-width: calc(100% - 24px - var(--gap));
            }

            &:nth-child(3), &:nth-child(4) {
                --td-width: calc(50% - (var(--gap) / 2));
            }

            .typo-label {
                display: flex;
            }
        }
    }
}
</style>